import {ActionIcon, Card, Divider, Grid, Group, Title} from "@mantine/core";
import {IconMessagePlus} from "@tabler/icons-react";
import {Entity} from "@ots-frontend/ots-data";
import {useTranslation} from "react-i18next";
import {EntityCommentList} from "../../../comment/EntityCommentList/EntityCommentList";
import {CommentModal} from "../../../comment/CommentModal/CommentModal";
import {useEntityCommentModal} from "../../../comment/EntityCommentModal/useEntityCommentModal";
import {HasAccess} from "../../../auth/HasAccess/HasAccess";

export type EntityCommentsCardProps = {
  entity: Entity;
}

export const EntityCommentsCard = (props: EntityCommentsCardProps) => {
  const {entity} = props;
  const {t} = useTranslation(["common"]);

  const {
    opened,
    handlers,
    onSubmit: onCommentSubmit,
    isCreating: isCommentCreating
  } = useEntityCommentModal({
    entity
  });

  return (
    <Card shadow="sm" padding="lg" radius="md" withBorder>
      <Group position="apart" pb="sm">
        <Title order={4}>{t("common.entity.comments.title", "Comments")}</Title>
        <HasAccess permissions={["edit"]}>
          <ActionIcon color="green" onClick={handlers.open}>
            <IconMessagePlus size={16}/>
          </ActionIcon>
        </HasAccess>
      </Group>
      <Divider/>
      <Grid>
        <Grid.Col span={12}>
          <EntityCommentList objectId={entity.id}/>
        </Grid.Col>
      </Grid>

      <CommentModal
        opened={opened}
        onClose={handlers.close}
        onSubmit={onCommentSubmit}
        loading={isCommentCreating}/>
    </Card>
  );
}
